module.exports = __webpack_public_path__ + "static/techradar-666660fea3d89b94614499646148b4b1.jpg";